module.exports = __webpack_public_path__ + "img/medio-billetera-personal.b2b3cd29.svg";